module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/093-basque-country-63b4c8f6f54946e09c67957428ee8106.svg";